<template>
  <div>
    <!--
      Este componente es ahora un contenedor/selector de vista.
      Hoy solo existe la vista de UCI, pero cuando se combine con Hospi
      aquí se decidirá cuál de las dos vistas renderizar
      (por ejemplo con un v-if basado en el tipo de servicio, o con
      <component :is="..."> ).
    -->
    <EvolucionUci
      :medical_act_id="medical_act_id"
      :addEv="addEv"
      :dete_out="dete_out"
      :dete_out_doctor="dete_out_doctor"
      :rolname="rolname"
      :typeDoctor="typeDoctor"
      @mtdSaveEditedEvolution="$emit('mtdSaveEditedEvolution')"
    />
  </div>
</template>

<script>
import EvolucionUci from "./Components/EvolucionUci.vue";

export default {
  name: "c-asistencial-uciadulto-historia-evolucionmedica",
  components: {
    EvolucionUci,
  },
  props: {
    medical_act_id: {
      type: Number,
      default: 0,
    },
    addEv: {
      type: Number,
      default: 0,
    },
    dete_out: {
      type: Boolean,
    },
    dete_out_doctor: {
      type: Boolean,
    },
    rolname: String,
    typeDoctor: {
      type: Number,
      default: 1,
    },
  },
};
</script>